export default __webpack_public_path__ + "static/saddlefinance-75ca5c40c2318b6fa57ae04dd6b058a2.jpg";